import "../../assets/css/views/justificationAbsences/justificationAbsences.css";
import { useTranslation } from "react-i18next";
import {
  Tabs,
} from "@veneer/core";
import LoaderModal from "../../components/Loader/loaderModal";
import SimpleMessageModalWithOpenClose from "../../components/Modals/SimpleMessageModalWithOpenClose";
import { useJustificationAbsences } from "../../hooks/justificationAbsences/useJustificationAbsences";
import TabCreateJustifications from "../../components/justificationAbsences/tabCreateJustifications";
import TabViewJustifications from "../../components/justificationAbsences/tabviewJustifications";

export default function JustificationAbsences() {
  const [t] = useTranslation("global");
  const {
    loading,
    loadingModal,
    openModalError,
    messageModalError,
    setOpenModalError,
    openModalMessage,
    setOpenModalMessage,
    messageModalMessage,
    setMessageModalError,
    setLoading,
    setLoadingModal,
    setMessageModalMessage,
    onChangeTab,
    currentPage
  } = useJustificationAbsences();

  return (
    <div className="justification-absences-container">
      {loading && (
        <div>
          <LoaderModal>
            <div>
              {" "}
              {t("header.loading")}
            </div>
          </LoaderModal>
        </div>
      )}
      <h4 className="justification-absences-title">
        {t("header.justificationAbsences")}
      </h4>

      <Tabs
        controlId="default"
        onChangeTab={(value) => onChangeTab(value)}
        selectedTabId={currentPage}
        tabs={[
          {
            id: 1,
            label: t("header.visualize"),
            content: (
              <TabViewJustifications
                setLoading={setLoading}
                setLoadingModal={setLoadingModal}
                setMessageModalError={setMessageModalError}
                setOpenModalError={setOpenModalError}
                setMessageModalMessage={setMessageModalMessage}
                setOpenModalMessage={setOpenModalMessage}
                loading={loading}
                callBackOnChangeTab={onChangeTab}
              />
            ),
          },
          {
            id: 2,
            label: t("header.create"),
            content: (
              <TabCreateJustifications 
                setLoading={setLoading}
                setLoadingModal={setLoadingModal}
                setMessageModalError={setMessageModalError}
                setOpenModalError={setOpenModalError}
                setMessageModalMessage={setMessageModalMessage}
                setOpenModalMessage={setOpenModalMessage}
                loading={loading}
                callBackOnChangeTab={onChangeTab}
              />
            ),
          },
        ]}
        type="attached"
      />

      {loadingModal && <LoaderModal />}

      <div style={{ position: "relative" }}>
        <SimpleMessageModalWithOpenClose
          modalMessage={messageModalMessage}
          modalTitle={t("modal.message")}
          setOpenCloseModal={setOpenModalMessage}
          showModal={openModalMessage}
        />
      </div>

      <div style={{ position: "relative" }}>
        <SimpleMessageModalWithOpenClose
          modalMessage={messageModalError}
          modalTitle={t("header.error")}
          setOpenCloseModal={setOpenModalError}
          showModal={openModalError}
        />
      </div>
    </div>
  );
}
